/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureACircleRightIcon20Solid = forwardRef('ArrowFigureACircleRightIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM5.1 10a.9.9 0 0 1 .9-.9h6.006l-1.693-1.536a.9.9 0 1 1 1.21-1.333l2.602 2.362a1.9 1.9 0 0 1 0 2.814l-2.602 2.362a.9.9 0 1 1-1.21-1.333l1.693-1.536H6a.9.9 0 0 1-.9-.9Z" })));
});
